var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "screen-list" },
    [
      _c("img", {
        staticClass: "logo",
        attrs: { src: require("@/assets/img/ASELogo_02.png"), alt: "" },
      }),
      _c("loading", {
        attrs: { active: _vm.isLoading, loader: "dots" },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _vm.tvData && _vm.tvData.FormatId === 1
        ? [
            _vm.tvData.Sorts[0].Frames[0].Type === 1
              ? _c(
                  "div",
                  {
                    staticClass: "yahome-table-wrap",
                    staticStyle: {
                      height: "100%",
                      width: "100%",
                      padding: "0",
                    },
                  },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.rows.slice(
                            (_vm.currentPage - 1) * _vm.pageSize,
                            _vm.currentPage * _vm.pageSize
                          ),
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "BlurName",
                            label: "姓名",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "目前階段名稱", align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    props.row.NowStageName !== null &&
                                    props.row.NowStageName
                                      ? [
                                          props.row.NowStageName.split("(")
                                            .length > 1
                                            ? _c("div", [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.row.NowStageName.split(
                                                        "("
                                                      )[0]
                                                    )
                                                  ),
                                                ]),
                                                _c("br"),
                                                _c("span", [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        props.row.NowStageName.split(
                                                          "("
                                                        )[1]
                                                      )
                                                  ),
                                                ]),
                                              ])
                                            : _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      props.row.NowStageName
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                        ]
                                      : [
                                          _vm._v(
                                            " " + _vm._s(props.row.NowStageName)
                                          ),
                                        ],
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1235315131
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "下個階段名稱", align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    props.row.NextStageName !== null &&
                                    props.row.NextStageName
                                      ? [
                                          props.row.NextStageName.split("(")
                                            .length > 1
                                            ? _c("div", [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.row.NextStageName.split(
                                                        "("
                                                      )[0]
                                                    )
                                                  ),
                                                ]),
                                                _c("br"),
                                                _c("span", [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        props.row.NextStageName.split(
                                                          "("
                                                        )[1]
                                                      )
                                                  ),
                                                ]),
                                              ])
                                            : _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      props.row.NextStageName
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                        ]
                                      : [
                                          _vm._v(
                                            " " +
                                              _vm._s(props.row.NextStageName)
                                          ),
                                        ],
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3355912554
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "NextStageExpectStartTime",
                            formatter: _vm.timeFormatter,
                            align: "center",
                            label: "下個階段開始時間",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "FlowExpectEndTime",
                            formatter: _vm.timeFormatter,
                            align: "center",
                            label: "本日結束時間",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "text-right" }, [
                      _vm._v(
                        " 第" +
                          _vm._s(_vm.currentPage) +
                          "頁，共" +
                          _vm._s(Math.ceil(_vm.rows.length / _vm.pageSize)) +
                          "頁 "
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm.tvData.Sorts[0].Frames[0].Type === 3
              ? _c(
                  "video",
                  {
                    ref: "videoRef0",
                    attrs: {
                      src: _vm.tvData.Sorts[0].Frames[0].Value,
                      width: "100%",
                      height: "100%",
                      muted: "muted",
                      loop: "loop",
                      controls: "",
                    },
                    domProps: { muted: true },
                  },
                  [
                    _c("track", {
                      attrs: {
                        src: "",
                        kind: "subtitles",
                        srclang: "zh",
                        label: "No item",
                        default: "",
                      },
                    }),
                    _c("track", {
                      attrs: {
                        src: "",
                        kind: "descriptions",
                        srclang: "en",
                        label: "No item",
                      },
                    }),
                  ]
                )
              : _vm._e(),
            _vm.tvData.Sorts[0].Frames[0].Type === 4
              ? _c("img", {
                  attrs: { src: _vm.tvData.Sorts[0].Frames[0].Value, alt: "" },
                })
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.tvData && _vm.tvData.FormatId === 2
        ? _c("div", { staticClass: "screen-wrap" }, [
            _vm.tvData.Sorts[0].Frames.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "screen",
                    class: {
                      h100:
                        _vm.tvData.Sorts[1].Frames.length === 0 &&
                        _vm.tvData.Sorts[0].Frames[0].Type === 1,
                    },
                  },
                  [
                    _vm.tvData.Sorts[0].Frames[0].Type === 1
                      ? _c(
                          "div",
                          {
                            staticClass: "yahome-table-wrap",
                            staticStyle: { height: "100%", padding: "0" },
                          },
                          [
                            _c(
                              "el-table",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  data: _vm.rows.slice(
                                    (_vm.currentPage - 1) * _vm.pageSize,
                                    _vm.currentPage * _vm.pageSize
                                  ),
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "BlurName",
                                    label: "姓名",
                                    align: "center",
                                    width: "120",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (props) {
                                          return [
                                            _vm.checkIsChinese(
                                              props.row.BlurName
                                            )
                                              ? [
                                                  props.row.BlurName.length <= 4
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              props.row.BlurName
                                                            )
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  props.row.BlurName.length > 4
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.row.BlurName.substr(
                                                              0,
                                                              4
                                                            )
                                                          )
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                ]
                                              : _vm._e(),
                                            !_vm.checkIsChinese(
                                              props.row.BlurName
                                            )
                                              ? [
                                                  _vm._l(
                                                    props.row.BlurName.split(
                                                      " "
                                                    ),
                                                    function (
                                                      splitName,
                                                      index
                                                    ) {
                                                      return [
                                                        index < 2
                                                          ? _c(
                                                              "span",
                                                              {
                                                                key: index,
                                                                staticStyle: {
                                                                  display:
                                                                    "block",
                                                                },
                                                              },
                                                              [
                                                                splitName.length <=
                                                                8
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            splitName
                                                                          )
                                                                      ),
                                                                    ])
                                                                  : _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          splitName.substr(
                                                                            0,
                                                                            7
                                                                          )
                                                                        ) + ".."
                                                                      ),
                                                                    ]),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    }
                                                  ),
                                                ]
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    276846413
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "目前階段名稱",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (props) {
                                          return [
                                            props.row.NowStageName !== null &&
                                            props.row.NowStageName
                                              ? [
                                                  props.row.NowStageName.split(
                                                    "("
                                                  ).length > 1
                                                    ? _c("div", [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.row.NowStageName.split(
                                                                "("
                                                              )[0]
                                                            )
                                                          ),
                                                        ]),
                                                        _c("br"),
                                                        _c("span", [
                                                          _vm._v(
                                                            "(" +
                                                              _vm._s(
                                                                props.row.NowStageName.split(
                                                                  "("
                                                                )[1]
                                                              )
                                                          ),
                                                        ]),
                                                      ])
                                                    : _c("div", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              props.row
                                                                .NowStageName
                                                            ) +
                                                            " "
                                                        ),
                                                      ]),
                                                ]
                                              : [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        props.row.NowStageName
                                                      )
                                                  ),
                                                ],
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2876804731
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "下個階段名稱",
                                    align: "center",
                                    width: "138",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (props) {
                                          return [
                                            props.row.NextStageName !== null &&
                                            props.row.NextStageName
                                              ? [
                                                  props.row.NextStageName.split(
                                                    "("
                                                  ).length > 1
                                                    ? _c("div", [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.row.NextStageName.split(
                                                                "("
                                                              )[0]
                                                            )
                                                          ),
                                                        ]),
                                                        _c("br"),
                                                        _c("span", [
                                                          _vm._v(
                                                            "(" +
                                                              _vm._s(
                                                                props.row.NextStageName.split(
                                                                  "("
                                                                )[1]
                                                              )
                                                          ),
                                                        ]),
                                                      ])
                                                    : _c("div", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              props.row
                                                                .NextStageName
                                                            ) +
                                                            " "
                                                        ),
                                                      ]),
                                                ]
                                              : [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        props.row.NextStageName
                                                      )
                                                  ),
                                                ],
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    672058218
                                  ),
                                }),
                                _c("el-table-column", {
                                  staticClass: "tColumnNonPadding",
                                  attrs: {
                                    prop: "NextStageExpectStartTime",
                                    formatter: _vm.timeFormatter,
                                    align: "center",
                                    label: "下個階段開始時間",
                                    width: "147",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "FlowExpectEndTime",
                                    formatter: _vm.timeFormatter,
                                    align: "center",
                                    label: "本日結束時間",
                                    width: "120",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "text-right lower-right" },
                              [
                                _vm._v(
                                  " 第" +
                                    _vm._s(_vm.currentPage) +
                                    "頁，共" +
                                    _vm._s(
                                      Math.ceil(_vm.rows.length / _vm.pageSize)
                                    ) +
                                    "頁 "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.tvData.Sorts[0].Frames[0].Type === 3
                      ? _c(
                          "video",
                          {
                            ref: "videoRef0",
                            attrs: {
                              src: _vm.tvData.Sorts[0].Frames[0].Value,
                              width: "100%",
                              height: "100%",
                              muted: "muted",
                              loop: "loop",
                              controls: "",
                            },
                            domProps: { muted: true },
                          },
                          [
                            _c("track", {
                              attrs: {
                                src: "",
                                kind: "subtitles",
                                srclang: "zh",
                                label: "No item",
                                default: "",
                              },
                            }),
                            _c("track", {
                              attrs: {
                                src: "",
                                kind: "descriptions",
                                srclang: "en",
                                label: "No item",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm.tvData.Sorts[0].Frames[0].Type === 4
                      ? _c("img", {
                          attrs: {
                            src: _vm.tvData.Sorts[0].Frames[0].Value,
                            alt: "",
                          },
                        })
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm.tvData.Sorts[1].Frames.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "screen",
                    class: {
                      h100:
                        _vm.tvData.Sorts[0].Frames.length === 0 &&
                        _vm.tvData.Sorts[1].Frames[0].Type === 1,
                    },
                  },
                  [
                    _vm.tvData.Sorts[1].Frames[0].Type === 1
                      ? _c(
                          "div",
                          {
                            staticClass: "yahome-table-wrap",
                            staticStyle: { height: "100%", padding: "0" },
                          },
                          [
                            _c(
                              "el-table",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  data: _vm.rows.slice(
                                    (_vm.currentPage - 1) * _vm.pageSize,
                                    _vm.currentPage * _vm.pageSize
                                  ),
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "BlurName",
                                    label: "姓名",
                                    align: "center",
                                    width: "110",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "目前階段名稱",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (props) {
                                          return [
                                            props.row.NowStageName !== null &&
                                            props.row.NowStageName
                                              ? [
                                                  props.row.NowStageName.split(
                                                    "("
                                                  ).length > 1
                                                    ? _c("div", [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.row.NowStageName.split(
                                                                "("
                                                              )[0]
                                                            )
                                                          ),
                                                        ]),
                                                        _c("br"),
                                                        _c("span", [
                                                          _vm._v(
                                                            "(" +
                                                              _vm._s(
                                                                props.row.NowStageName.split(
                                                                  "("
                                                                )[1]
                                                              )
                                                          ),
                                                        ]),
                                                      ])
                                                    : _c("div", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              props.row
                                                                .NowStageName
                                                            ) +
                                                            " "
                                                        ),
                                                      ]),
                                                ]
                                              : [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        props.row.NowStageName
                                                      )
                                                  ),
                                                ],
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2876804731
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "下個階段名稱",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (props) {
                                          return [
                                            props.row.NextStageName !== null &&
                                            props.row.NextStageName
                                              ? [
                                                  props.row.NextStageName.split(
                                                    "("
                                                  ).length > 1
                                                    ? _c("div", [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.row.NextStageName.split(
                                                                "("
                                                              )[0]
                                                            )
                                                          ),
                                                        ]),
                                                        _c("br"),
                                                        _c("span", [
                                                          _vm._v(
                                                            "(" +
                                                              _vm._s(
                                                                props.row.NextStageName.split(
                                                                  "("
                                                                )[1]
                                                              )
                                                          ),
                                                        ]),
                                                      ])
                                                    : _c("div", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              props.row
                                                                .NextStageName
                                                            ) +
                                                            " "
                                                        ),
                                                      ]),
                                                ]
                                              : [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        props.row.NextStageName
                                                      )
                                                  ),
                                                ],
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    672058218
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "NextStageExpectStartTime",
                                    formatter: _vm.timeFormatter,
                                    align: "center",
                                    label: "下個階段開始時間",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "FlowExpectEndTime",
                                    formatter: _vm.timeFormatter,
                                    align: "center",
                                    label: "本日結束時間",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "text-right" }, [
                              _vm._v(
                                " 第" +
                                  _vm._s(_vm.currentPage) +
                                  "頁，共" +
                                  _vm._s(
                                    Math.ceil(_vm.rows.length / _vm.pageSize)
                                  ) +
                                  "頁 "
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.tvData.Sorts[1].Frames[0].Type === 3
                      ? _c(
                          "video",
                          {
                            key: _vm.tvData.Sorts[1].Frames[0].Value,
                            ref: "videoRef1",
                            attrs: {
                              src: _vm.tvData.Sorts[1].Frames[0].Value,
                              width: "100%",
                              height: "100%",
                              muted: "muted",
                              loop: "loop",
                              controls: "",
                            },
                            domProps: { muted: true },
                          },
                          [
                            _c("track", {
                              attrs: {
                                src: "",
                                kind: "subtitles",
                                srclang: "zh",
                                label: "No item",
                                default: "",
                              },
                            }),
                            _c("track", {
                              attrs: {
                                src: "",
                                kind: "descriptions",
                                srclang: "en",
                                label: "No item",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm.tvData.Sorts[1].Frames[0].Type === 4
                      ? _c("img", {
                          attrs: {
                            src: _vm.tvData.Sorts[1].Frames[0].Value,
                            alt: "",
                          },
                        })
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.tvData && _vm.tvData.FormatId === 2
        ? _c("div", { staticClass: "screen-wrap" }, [
            _vm.tvData.Sorts[2].Frames.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "screen",
                    class: {
                      h100:
                        _vm.tvData.Sorts[3].Frames.length === 0 &&
                        _vm.tvData.Sorts[2].Frames[0].Type === 1,
                    },
                  },
                  [
                    _vm.tvData.Sorts[2].Frames[0].Type === 1
                      ? _c(
                          "div",
                          {
                            staticClass: "yahome-table-wrap",
                            staticStyle: { height: "100%", padding: "0" },
                          },
                          [
                            _c(
                              "el-table",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  data: _vm.rows.slice(
                                    (_vm.currentPage - 1) * _vm.pageSize,
                                    _vm.currentPage * _vm.pageSize
                                  ),
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "BlurName",
                                    label: "姓名",
                                    align: "center",
                                    width: "110",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "目前階段名稱",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (props) {
                                          return [
                                            props.row.NowStageName !== null &&
                                            props.row.NowStageName
                                              ? [
                                                  props.row.NowStageName.split(
                                                    "("
                                                  ).length > 1
                                                    ? _c("div", [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.row.NowStageName.split(
                                                                "("
                                                              )[0]
                                                            )
                                                          ),
                                                        ]),
                                                        _c("br"),
                                                        _c("span", [
                                                          _vm._v(
                                                            "(" +
                                                              _vm._s(
                                                                props.row.NowStageName.split(
                                                                  "("
                                                                )[1]
                                                              )
                                                          ),
                                                        ]),
                                                      ])
                                                    : _c("div", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              props.row
                                                                .NowStageName
                                                            ) +
                                                            " "
                                                        ),
                                                      ]),
                                                ]
                                              : [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        props.row.NowStageName
                                                      )
                                                  ),
                                                ],
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2876804731
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "下個階段名稱",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (props) {
                                          return [
                                            props.row.NextStageName !== null &&
                                            props.row.NextStageName
                                              ? [
                                                  props.row.NextStageName.split(
                                                    "("
                                                  ).length > 1
                                                    ? _c("div", [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.row.NextStageName.split(
                                                                "("
                                                              )[0]
                                                            )
                                                          ),
                                                        ]),
                                                        _c("br"),
                                                        _c("span", [
                                                          _vm._v(
                                                            "(" +
                                                              _vm._s(
                                                                props.row.NextStageName.split(
                                                                  "("
                                                                )[1]
                                                              )
                                                          ),
                                                        ]),
                                                      ])
                                                    : _c("div", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              props.row
                                                                .NextStageName
                                                            ) +
                                                            " "
                                                        ),
                                                      ]),
                                                ]
                                              : [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        props.row.NextStageName
                                                      )
                                                  ),
                                                ],
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    672058218
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "NextStageExpectStartTime",
                                    formatter: _vm.timeFormatter,
                                    align: "center",
                                    label: "下個階段開始時間",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "FlowExpectEndTime",
                                    formatter: _vm.timeFormatter,
                                    align: "center",
                                    label: "本日結束時間",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "text-right" }, [
                              _vm._v(
                                " 第" +
                                  _vm._s(_vm.currentPage) +
                                  "頁，共" +
                                  _vm._s(
                                    Math.ceil(_vm.rows.length / _vm.pageSize)
                                  ) +
                                  "頁 "
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.tvData.Sorts[2].Frames[0].Type === 3
                      ? _c(
                          "video",
                          {
                            key: _vm.tvData.Sorts[2].Frames[0].Value,
                            ref: "videoRef2",
                            attrs: {
                              src: _vm.tvData.Sorts[2].Frames[0].Value,
                              width: "100%",
                              height: "100%",
                              muted: "muted",
                              loop: "loop",
                              controls: "",
                            },
                            domProps: { muted: true },
                          },
                          [
                            _c("track", {
                              attrs: {
                                src: "",
                                kind: "subtitles",
                                srclang: "zh",
                                label: "No item",
                                default: "",
                              },
                            }),
                            _c("track", {
                              attrs: {
                                src: "",
                                kind: "descriptions",
                                srclang: "en",
                                label: "No item",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm.tvData.Sorts[2].Frames[0].Type === 4
                      ? _c("img", {
                          attrs: {
                            src: _vm.tvData.Sorts[2].Frames[0].Value,
                            alt: "",
                          },
                        })
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm.tvData.Sorts[3].Frames.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "screen",
                    class: {
                      h100:
                        _vm.tvData.Sorts[2].Frames.length === 0 &&
                        _vm.tvData.Sorts[3].Frames[0].Type === 1,
                    },
                  },
                  [
                    _vm.tvData.Sorts[3].Frames[0].Type === 1
                      ? _c(
                          "div",
                          {
                            staticClass: "yahome-table-wrap",
                            staticStyle: { height: "100%", padding: "0" },
                          },
                          [
                            _c(
                              "el-table",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  data: _vm.rows.slice(
                                    (_vm.currentPage - 1) * _vm.pageSize,
                                    _vm.currentPage * _vm.pageSize
                                  ),
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "BlurName",
                                    label: "姓名",
                                    align: "center",
                                    width: "110",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "目前階段名稱",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (props) {
                                          return [
                                            props.row.NowStageName !== null &&
                                            props.row.NowStageName
                                              ? [
                                                  props.row.NowStageName.split(
                                                    "("
                                                  ).length > 1
                                                    ? _c("div", [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.row.NowStageName.split(
                                                                "("
                                                              )[0]
                                                            )
                                                          ),
                                                        ]),
                                                        _c("br"),
                                                        _c("span", [
                                                          _vm._v(
                                                            "(" +
                                                              _vm._s(
                                                                props.row.NowStageName.split(
                                                                  "("
                                                                )[1]
                                                              )
                                                          ),
                                                        ]),
                                                      ])
                                                    : _c("div", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              props.row
                                                                .NowStageName
                                                            ) +
                                                            " "
                                                        ),
                                                      ]),
                                                ]
                                              : [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        props.row.NowStageName
                                                      )
                                                  ),
                                                ],
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2876804731
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "下個階段名稱",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (props) {
                                          return [
                                            props.row.NextStageName !== null &&
                                            props.row.NextStageName
                                              ? [
                                                  props.row.NextStageName.split(
                                                    "("
                                                  ).length > 1
                                                    ? _c("div", [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.row.NextStageName.split(
                                                                "("
                                                              )[0]
                                                            )
                                                          ),
                                                        ]),
                                                        _c("br"),
                                                        _c("span", [
                                                          _vm._v(
                                                            "(" +
                                                              _vm._s(
                                                                props.row.NextStageName.split(
                                                                  "("
                                                                )[1]
                                                              )
                                                          ),
                                                        ]),
                                                      ])
                                                    : _c("div", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              props.row
                                                                .NextStageName
                                                            ) +
                                                            " "
                                                        ),
                                                      ]),
                                                ]
                                              : [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        props.row.NextStageName
                                                      )
                                                  ),
                                                ],
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    672058218
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "NextStageExpectStartTime",
                                    formatter: _vm.timeFormatter,
                                    align: "center",
                                    label: "下個階段開始時間",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "FlowExpectEndTime",
                                    formatter: _vm.timeFormatter,
                                    align: "center",
                                    label: "本日結束時間",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "text-right" }, [
                              _vm._v(
                                " 第" +
                                  _vm._s(_vm.currentPage) +
                                  "頁，共" +
                                  _vm._s(
                                    Math.ceil(_vm.rows.length / _vm.pageSize)
                                  ) +
                                  "頁 "
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.tvData.Sorts[3].Frames[0].Type === 3
                      ? _c(
                          "video",
                          {
                            key: _vm.tvData.Sorts[3].Frames[0].Value,
                            ref: "videoRef3",
                            attrs: {
                              src: _vm.tvData.Sorts[3].Frames[0].Value,
                              width: "100%",
                              height: "100%",
                              muted: "muted",
                              loop: "loop",
                              controls: "",
                            },
                            domProps: { muted: true },
                          },
                          [
                            _c("track", {
                              attrs: {
                                src: "",
                                kind: "subtitles",
                                srclang: "zh",
                                label: "No item",
                                default: "",
                              },
                            }),
                            _c("track", {
                              attrs: {
                                src: "",
                                kind: "descriptions",
                                srclang: "en",
                                label: "No item",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm.tvData.Sorts[3].Frames[0].Type === 4
                      ? _c("img", {
                          attrs: {
                            src: _vm.tvData.Sorts[3].Frames[0].Value,
                            alt: "",
                          },
                        })
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }